import React from "react";

interface ContainerProps {
  className?: string | string[];
  children?: React.ReactNode;
}

function Container({ className, children }: ContainerProps) {
  let styles = {};

  switch (typeof className) {
    case "string":
      styles = { className: className };
      break;
    case "object":
      if (Array.isArray(className)) {
        const classes = className.join(" ");
        styles = { className: classes };
      }
      break;
    default:
      break;
  }

  styles = { className: "container", ...styles };

  return <div {...styles}>{children}</div>;
}

export default Container;
